/**
 * @author Francesco Costa
 * @package Ucis.JS
 *
 * Main entry file for `adminbau` template Javascript functions.
 *
 * This file works also as reference, to understand what is imported and why.
 * Because those functions were written prior to PWA concept and divided in JS and PHP file, they are not class oriented.
 *
 * In the bottom, you can see the Sos and the Activity.js file are loaded in a "lazy" way, only if there is necessity.
 */
// External Deps
import doc_ready from 'document-ready';
import jq from 'jquery';
import axios from 'axios';

window.jQuery = jq;
window.axios = axios;

// Internal deps
import * as AsdLoader from './adminbau/chunkLoaders';
import {showAlertNoToken, showAlertNoTelegram} from './adminbau/profile.js';
import AsdModals from './util/modal.js';
import initMaterialize from './adminbau/materialize-css.js';
import AsdForm from './form/AsdForm';
// interface helper
import activityAnswer from './adminbau/activity.js';
import copy2clipboard from './adminbau/copy2clip.js';
import * as TimeAgo from './adminbau/timeago';

// standalone components
// TODO remove them and place in different chunks with diferential loading only if required
import GroupManager from './group/GroupManager.js';
import GpxZipper from './activity/GpxZipper.js';

import ImageUploader from "./objectStorage/ImageUploader.js";
import Insurances from "./adminbau/insurances/Insurances.js";
import AsdS3Directory from "./adminbau/s3directory";
import AsdHistory from "./adminbau/history";

AsdModals.init();
TimeAgo.init();
AsdForm.init();

doc_ready(() => {

    initMaterialize();
    copy2clipboard();
    activityAnswer();
    GroupManager.init();

    // TODO put apart in his own file (with class and init)
    if (window.hasOwnProperty('AsdToken') && window.AsdToken !== null) {
        let token = window.AsdToken;
        window.axios.defaults.headers.common = {'Authorization': `Bearer ${token}`};

        // Questi componenti necessitano di avere una API key

        GpxZipper.init();
        AsdHistory.init();
        ImageUploader.init();
        Insurances.init();
        AsdS3Directory.init();

        // if (window.hasOwnProperty('AsdChatId') && window.AsdChatId === 0) {
        //     showAlertNoTelegram();
        // }
    }
    // else if (window.hasOwnProperty('asdProfileType') && window.asdProfileType === 'person') {
    //     showAlertNoToken();
    // }



    let apps = document.querySelectorAll('.asd-app');
    apps.forEach(x => {
        let app = x.getAttribute('data-app');
        switch (app) {
            case 'edit-partecipants':
            case 'person-statistics':
            case 'group-statistics':
                if (window.AsdToken === null) {
                    console.log('Errore: questa app non funziona senza TOKEN', x);
                    x.innerHTML = 'Questa parte del gestionale non funziona se non hai mai associato @Ucis_Bot di telegram al tuo account'
                    return;
                }
                if (!window.AsdActivity_loaded) {
                    AsdLoader.Activity(apps)
                        .then( () => {
                            window.AsdActivity_loaded = true;
                        });
                }
                break;
            case 'chat-personlist':
                AsdLoader.ChatFromPersonFilter(x);
                break;
            case 'send-message':
                AsdLoader.NewMessage(x);
                break;
            case 'asd-sos':
                AsdLoader.Sos();
                break;
            default:
                console.log('Error with loading Activity APP: <' + app + '> from:', x);
        }
    });
});


